import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'
import { Form } from 'factorial-form'
import { ExpensesSignedInvoiceTax } from 'generated/resources/graphql'

import MoneyField from 'modules/core/components/Inputs/MoneyField'
import i18n from 'modules/core/lib/i18n'

export interface InvoiceTax extends ExpensesSignedInvoiceTax {
  id: string
}
interface TaxFieldProps {
  id: string
  tax: InvoiceTax
  currency: string
  onChange: (id: string, data: Record<string, number>) => void
  onRemove: (id: string) => void
  isReadonly: boolean
}

const TaxField = ({ id, tax, currency, onChange, onRemove, isReadonly }: TaxFieldProps) => {
  const formRef = new Form(
    {
      percentage: tax.percentage?.toString(),
      amount: tax.amount,
      base_amount: tax.baseAmount,
    },
    {
      percentage: 'string',
      amount: 'cents',
      base_amount: 'cents',
    }
  )
  const [form] = React.useState(formRef)

  const onFieldChange = () => {
    onChange(id, form.data())
  }
  const onFieldRemove = () => {
    onRemove(id)
  }

  return (
    <Box
      gap="s16"
      alignItems="center"
      paddingTop="s16"
      border={{ top: { width: 's1', style: 'solid', color: 'grey400' } }}
    >
      <Box flexDirection="row" gap="s16" width="full">
        <MoneyField
          mandatory
          placeholder="0"
          label={i18n.t('expenses.settings.signed_invoices.detail.form.fields.base_amount')}
          field={form.get('base_amount')}
          currency={currency}
          onChange={onFieldChange}
          readonly={isReadonly}
        />
        <MoneyField
          mandatory
          placeholder="0"
          label={i18n.t('expenses.settings.signed_invoices.detail.form.fields.vat_percentage')}
          field={form.get('percentage')}
          currency={'%'}
          onChange={onFieldChange}
          readonly={isReadonly}
        />
      </Box>

      <Box flexDirection="row" gap="s16" alignItems="flexEnd" width="full">
        <MoneyField
          mandatory
          placeholder="0"
          label={i18n.t('expenses.settings.signed_invoices.detail.form.fields.vat_amount')}
          field={form.get('amount')}
          currency={currency}
          onChange={onFieldChange}
          readonly={isReadonly}
        />
        {!isReadonly && (
          <Box paddingBottom="s8" width="full" alignItems="flexStart">
            <Button type="secondary" onClick={onFieldRemove} iconName="delete" />
          </Box>
        )}
      </Box>
    </Box>
  )
}

export default TaxField
